export default {
  name: 'marking--inventoryH',
  apiService: 'shoes',
  apiPath: '/admin/inventory_h',
};